import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.6719 0.953125C13.1094 1.39062 13.082 2.07422 12.6445 2.48438L7.61328 7.29688C7.20312 7.70703 6.51953 7.70703 6.10938 7.29688L1.07812 2.48438C0.640625 2.07422 0.613281 1.39062 1.05078 0.953125C1.46094 0.515625 2.14453 0.488281 2.58203 0.925781L6.875 5L11.1406 0.925781C11.3594 0.707031 11.6328 0.625 11.9062 0.625C12.1797 0.625 12.4805 0.734375 12.6719 0.953125Z",
		fill: "#78909C"
	})]
});
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
